import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { Edit, Close, PlayArrow } from "@material-ui/icons";
import axios from "axios";
import Cookies from "universal-cookie";
const cookies = new Cookies();

export default class ContinueYtdAdj extends Component {
  constructor() {
    super();
    this.state = {
      updated_by: cookies.get("email"),
      showEditModal: false,
      disableSubmit: false,
      status: 0,
      hasError: false,
      errMessage: "",
    };
    this.handleshowAddModal = this.handleshowAddModal.bind(this);
  }

  handleshowAddModal = (e) => {
    this.setState({ showEditModal: !this.state.showEditModal });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ disableSubmit: true });
    axios
      .post("api/ytd_continue/" + this.props.transId, this.state)
      .then((res) => {
        this.props.parentCallback(true);
        this.setState({ showEditModal: false, disableSubmit: false });
      })
      .catch((err) => {
        this.setState({
          disableSubmit: false,
          hasError: true,
          errMessage: err.response.data.message,
        });
      });
  };

  render() {
    return (
      <>
        <button
          className="btn btn-outline-info btn-sm float-right"
          title="Continue Ytd Adjustment"
          onClick={this.handleshowAddModal}
        >
          <PlayArrow />
        </button>
        <Modal
          size="md"
          show={this.state.showEditModal}
          onHide={() =>
            this.setState({ showEditModal: !this.state.showEditModal })
          }
        >
          <Modal.Header closeButton>
            <h4>Continue Ytd Adjustment</h4>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <div
                  className={
                    this.state.hasError
                      ? "alert alert-danger"
                      : "alert alert-danger d-none"
                  }
                  role="alert"
                >
                  {this.state.errMessage}
                </div>
              </div>
            </div>
            <form onSubmit={this.handleSubmit} id="contact-form">
              <div className="row">
                <div className="form-group col-md-12 col-sm-12">
                  <label>Are you sure?</label>
                </div>
              </div>

              <div className="float-right">
                <button
                  type="submit"
                  className="btn btn-primary btn-sm mr-2"
                  disabled={this.state.disableSubmit}
                >
                  Continue Ytd Adjustment
                </button>
                <button
                  onClick={this.handleshowAddModal}
                  className="btn btn-danger btn-sm"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
